const InitialState = []

const CartData = (state = InitialState, action) => {
    switch (action.type) {
        case "ADD_ITEM_DATA":
            var product = action.data
            var exist = state.find((e) => e._id == product._id)
            if (exist) {
                return state.map((data) => data._id == product._id ? { ...data, qty: data.qty + 1 } : data)
            } else {
                return state = [...state, { ...product, qty: 1 }]
            }
            break;
        case "REMOVE_ITEM_DATA":
            var product = action.data
            var exist = state.find((e) => e._id == product._id)
            if (exist) {
                if (exist.qty <= 1) {
                    return state.filter((data) => data._id != product._id)
                } else {
                    return state.map((data) => data._id == product._id ? { ...data, qty: data.qty - 1 } : data)
                }
            } else {
                return state = [...state, { ...product, qty: 1 }]
            }
            break;
        case "DELETE_ITEM_DATA":
            var product = action.data
            return state.filter((data) => data._id != product._id)
            break;
        default:
            return state
            break;
    }

}

export default CartData